import FeatureTable from '@/common/ui/FeatureTable';
import { ProIcon } from '@/common/ui/UpgradeButton';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@shadcn/components/card';

export default function InsightsFeatureGate() {
  return (
    <div className="flex items-center justify-center h-full p-6">
      <Card>
        <CardContent>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <ProIcon size={5} />
              <span>
                Insights are available on a Spellcaster Pro subscription
              </span>
            </CardTitle>
            <CardDescription>
              See what else you get on a Spellcaster Pro subscription below
            </CardDescription>
          </CardHeader>

          <FeatureTable showRecommended showPricing showCTAs />
        </CardContent>
      </Card>
    </div>
  );
}
